<template>
  <upload-files includeMimeTypeFile
    :contentFiles="contentFiles"
    @uploadsFinished="uploadOnDatabase"
  >
  </upload-files>
</template>
<script>

import UploadFiles from '@/components/upload/index'
import { updateContent } from "@/firebase/api/content";
import cardTypes from "./cardTypes";

export default {
  props: {
    contentFiles: { type: Array, required: true }
  },
  components: { UploadFiles },
  data: () => ({ cardTypes }),
  methods: {
    overwriteFile(file) {
      delete file.overwrite
      const finder = currentFile => currentFile.title === file.title
      const fileToBeOverwrited = this.contentFiles.find(finder)
      const index = this.contentFiles.indexOf(fileToBeOverwrited)
      this.contentFiles.splice(index,1,file)
    },
    addFileToArray(file) {
      const filter = cardType => file.mimeType.includes(cardType.type)
      if (file.url) {
        const filteredCardType = this.cardTypes.filter(filter)[0] 
        file.mimeType = filteredCardType ? filteredCardType.mimeType : cardTypes[0].mimeType;
        if(file.overwrite)
          this.overwriteFile(file)
        else {
          delete file.overwrite
          this.contentFiles.push(file);
        }
      }
    },
    uploadOnDatabase(resultFiles) {
      resultFiles.forEach(this.addFileToArray)
      const { chapterID, contentID } = this.$route.params;
      const files = this.contentFiles;
      updateContent(chapterID, contentID, { files });
    },
  }
}
</script>
